import I18n from 'core/i18n';

export type DatadisExpirationStatus = 'expired' | 'soon' | 'valid' | 'unknown' | 'pending';

interface DatadisExpiration {
  status: DatadisExpirationStatus;
  text: string;
}

const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
};

export const getDatadisExpirationStatus = (
  fechaCaducidadDatadis?: string,
  today: Date = new Date(),
  estadoRenovacionDatadis?: string,
): DatadisExpiration => {
  if (!fechaCaducidadDatadis) {
    if (estadoRenovacionDatadis === 'pendiente_confirmacion') {
      return { status: 'pending', text: I18n.t('DatadisRenewal.pendingConfirmation') };
    }
    return { status: 'unknown', text: I18n.t('DatadisRenewal.unknown') };
  }

  const fechaCaducidad = new Date(`${fechaCaducidadDatadis}T00:00:00`);
  const fechaFormateada = formatDate(fechaCaducidad);
  const inicioHoy = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diasRestantes = Math.ceil((fechaCaducidad.getTime() - inicioHoy.getTime()) / 86400000);

  if (diasRestantes < 0) {
    return { status: 'expired', text: I18n.t('DatadisRenewal.expired', { date: fechaFormateada }) };
  }

  if (diasRestantes <= 30) {
    return {
      status: 'soon',
      text:
        diasRestantes === 0
          ? I18n.t('DatadisRenewal.expiresToday', { date: fechaFormateada })
          : I18n.t(diasRestantes === 1 ? 'DatadisRenewal.expiresInOneDay' : 'DatadisRenewal.expiresInDays', {
              days: diasRestantes,
              date: fechaFormateada,
            }),
    };
  }

  return { status: 'valid', text: I18n.t('DatadisRenewal.validUntil', { date: fechaFormateada }) };
};
